<template>
  <div>
    <b-row>
      <!-- Search -->
      <b-col
        cols="12"
        class="mt-2 mb-4"
      >
        <div class="d-flex align-items-center justify-content-end">
          <b-form-input
            v-model="searchValue"
            class="d-inline-block mr-1"
            placeholder="Filtrar..."
            @keyup="filtro($event, 'title', filterGlobal)"
          />
        </div>
      </b-col>
    </b-row>

    <b-row class="match-height">
      <div
        v-for="item in magazineAll"
        :key="item.id"
        style="margin: 5px;"
      >
        <a
          :href="thumb+'/storage/magazine/pdf/'+item.path"
          target="_blank"
        >
          <b-card
            :img-src="thumb+'/storage/magazine/thumb/'+item.thumb"
            img-top
            :title="item.title"
            md="4"
            style="max-width: 20rem;display:block;margin: 0 auto;"
          />
        </a>
      </div>
    </b-row>
  </div>
</template>

<script>
// import { BLink } from 'bootstrap-vue'
import { mapActions } from 'vuex'

export default {
  components: {
    // BLink,
  },
  data() {
    return {
      thumb: process.env.VUE_APP_BASE_PUBLIC,
      magazineAll: [],
      searchValue: null,
    }
  },
  computed: {
  },
  async mounted() {
    await this.getAllMagazine()
    console.log(this.$store.state.magazine.magazine)
    this.magazineAll = this.$store.state.magazine.magazine
  },
  methods: {
    filtro(e, propriedadePesquisa, filterGlobal) {
      if (e.target.value.trim() !== '') {
        const lista = this.$store.state.magazine.magazine
        const result = filterGlobal(e, lista, propriedadePesquisa)
        this.magazineAll = result
      } else {
        this.magazineAll = this.$store.state.magazine.magazine
      }
    },
    ...mapActions('magazine', [
      'ActionListAllMagazine',
    ]),
    async getAllMagazine() {
      await this.ActionListAllMagazine()
    }
  },
}
</script>
